import React from 'react';
import {connect} from "react-redux";
import Icon from "../../../../../../../../../../../../../components/icon";
import {
    commentContentToEdit,
    parseContactOnCommentToEdit
} from "../../../../../../../../../../../../../../actions/commentActions";
import {
    commentToEditContactSearchResult,
    resetCommentToEditContactSearchResult
} from "../../../../../../../../../../../../../../actions/contactActions";
import './index.css';

function CommentToEditAutoComplete (props) {

    const {
        isSearchingContacts,
        commentToEditContactSearchResult,
        commentContentToEdit,
        setCommentContentToEdit,
        setParseContactOnCommentToEdit,
        resetCommentToEditContactSearchResult
    } = props;

    const clickHandler = (e) => {
        setCommentContentToEdit(commentContentToEdit.replace(/@\w+$/g, '@' + e.currentTarget.dataset.contactEmail));
        resetCommentToEditContactSearchResult();
        setParseContactOnCommentToEdit(null);
        e.currentTarget.parentElement.parentElement.children[1].value = e.currentTarget.parentElement.parentElement.children[1].value.replace(/@\w+$/g, '@' + e.currentTarget.dataset.contactEmail);
        e.currentTarget.parentElement.parentElement.children[1].focus();
    }

    return (
        <div className="comment-to-edit-autocomplete">
            {
                isSearchingContacts === false
                    ?
                    commentToEditContactSearchResult.map((item) => (
                        <div key={item.id} onClick={clickHandler} data-contact-email={item.email} className="d-flex contact p-3">
                            <div>
                                <p className="mb-0"><strong>{item.name}</strong></p>
                                <p className="mb-0">{item.email}</p>
                            </div>
                        </div>
                    ))
                    :
                    <div className="p-3">
                        <Icon animated={'pulse'} name="spinner"/>
                    </div>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        commentToEditContactSearchResult: state.contactReducer.commentToEditContactSearchResult,
        isSearchingContacts: state.contactReducer.isSearchingContacts,
        commentContentToEdit: state.commentReducer.commentContentToEdit
    };
};

const mapDispatchToProps = (dispatch) => ({
    setCommentContentToEdit: (string) => dispatch(commentContentToEdit(string)),
    setCommentToEditContactSearchResult: (string) => dispatch(commentToEditContactSearchResult(string)),
    setParseContactOnCommentToEdit: (array) => dispatch(parseContactOnCommentToEdit(array)),
    resetCommentToEditContactSearchResult: () => dispatch(resetCommentToEditContactSearchResult()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CommentToEditAutoComplete);
